import { ExtensionsProperties, MetadataSerialization } from '@adaptiva/metadata/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BaseAuthoringPropertiesComponent } from '../base-authoring-component';

@Component({
	standalone: false,
	selector: 'ada-extensions-properties',
	templateUrl: './extensions-properties.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class ExtensionsPropertiesComponent extends BaseAuthoringPropertiesComponent<ExtensionsProperties> {

	public propertyConstructor: MetadataSerialization.Deserializable<ExtensionsProperties> = ExtensionsProperties;

}
